import type { ComponentType } from 'react'

import { IconCard, IconShield, IconStore, IconTicket } from '@/app/components/atoms/Icons'
import type { IconProps } from '@/app/components/atoms/Icons'

/** Nombre accesible de la barra flotante de compra. */
export const BUY_BOX_LABEL = 'Compra de entradas'

/** Tamaño de los iconos de la franja de ventajas (Figma: 16px). */
export const BENEFIT_ICON_SIZE = 16

export interface BuyBoxBenefit {
  readonly Icon: ComponentType<IconProps>
  readonly label: string
}

/**
 * Franja de ventajas de la barra desde tablet, solo para usuarios sin sesión.
 *
 * Los textos coinciden con los del módulo CMS `Tranquilidad`, pero **no** se
 * importan de allí a propósito: aquel es un módulo de página compuesto desde el
 * CMS y acoplar la ficha a él para reaprovechar cuatro cadenas dejaría a la PDP
 * dependiendo de un módulo que puede cambiar por razones ajenas. El asterisco
 * es el que trae el diseño.
 */
export const BENEFITS: readonly BuyBoxBenefit[] = [
  { Icon: IconShield, label: 'Seguro de cancelación incluido*' },
  { Icon: IconTicket, label: 'Compra de entradas oficiales*' },
  { Icon: IconCard, label: 'Financiación sin intereses y a tu medida*' },
  { Icon: IconStore, label: 'Atención en tiendas El Corte Inglés*' },
]

/**
 * `module_name` del `click` del enlace al recinto de la barra de compra.
 * Se aplica por criterio transversal la fila "Click en (Localización)" de
 * `Ubicación Detalles Producto.csv` (`venue_location`): no hay ficha propia de
 * la barra de compra.
 */
export const BUY_BOX_VENUE_MODULE_NAME = 'venue_location'
